{
  "common" : {
    "customFieldExistsError" : "Tilpasset filt med dette navnet finnes allerede",
    "uniqueKeyNotUniqueError" : "Denne viktige er ikke unik",
    "save" : "Lagre",
    "saving" : "Lagrer",
    "integrate" : "Integrere",
    "preview" : "Forhåndsvisning",
    "back" : "Tilbake",
    "alert" : "Varsel",
    "proceed" : "Fortsett",
    "cancel" : "Kanseller",
    "delete" : "Slett",
    "embed" : "Sett inn",
    "link" : "Sammenkoble",
    "iframeEmbed" : "Iframe innebygd",
    "styles" : "Stiler",
    "options" : "Alternativer",
    "quickAdd" : "Hurtigtillegg",
    "customFields" : "Egendefinerte felt",
    "addObjectFields" : "Legge til gjenstandfelter",
    "personalInfo" : "Personlig informasjon",
    "contactInfo" : "Kontaktinformasjon",
    "submit" : "Send inn",
    "address" : "Adresse",
    "customized" : "Tilpasset",
    "layout" : "Oppsett",
    "showLabel" : "Vis etikett",
    "background" : "Bakgrunn",
    "buttonBackground" : "Bakgrunn for Knapp",
    "fontColour" : "Skriftfarge",
    "textFontColour" : "Text Font Colour",
    "subTextFontColour" : "Sub Text Font Colour",
    "selectThemes" : "Velge tema",
    "filled" : "Utfylt",
    "textOnly" : "Kun Hoveddel",
    "border" : "Kant",
    "borderType" : "Kanttype",
    "cornerRadius" : "Hjørneradius",
    "width" : "Bredde",
    "padding" : "Padding",
    "top" : "Topp",
    "bottom" : "Bunn",
    "left" : "Venstre",
    "right" : "Høyre",
    "center" : "Senter",
    "default" : "Form Default",
    "default" : "Standard",
    "formDefault" : "Standardskjema",
    "shadow" : "Skygge",
    "color" : "Farge",
    "horizontal" : "Horisontal",
    "vertical" : "Vertikal",
    "blur" : "Uskarphet",
    "spread" : "Spredning",
    "fieldStyle" : "Feltstil",
    "fontColor" : "Skriftfarge",
    "inputTextFillColor" : "Fyllfarge for inndatatekst",
    "inputTextColor" : "Tekstfarge for inndata",
    "primaryColor" : "Primærfarge",
    "primaryColorTooltip" : "Styrer Farge for svevetilstand og Dynamisk Land.",
    "inputTextColorTooltip" : "Styrer Farge av Tekste skrevet i tilbakemelding Felter.",
    "mapPrimaryColorToButtonColor" : "Kartlegg PRIMÆR Farge til Knapp Farge",
    "label" : "Merkelapp",
    "fontFamily" : "Fontfamilie",
    "size" : "Størrelse",
    "weight" : "Vekt",
    "placeholder" : "Plassholder",
    "customCSS" : "Tilpasset CSS",
    "backgroundImage" : "Bakgrunnsbilde",
    "headerImage" : "Overskriftsbilde",
    "miscellaneous" : "Diverse",
    "agencyBranding" : "Byråmerkevarebygging",
    "imageUploadMessage" : "Klikk eller dra et bilde til dette området for å laste opp",
    "backgroundImageTooltipMessage" : "Bakgrunnsbildet er ment å dekke hele siden, og gir et visuelt tiltalende bakteppe for skjemaet. For å se bakgrunnsbildet, klikk på forhåndsning.",
    "headerImageTooltipMessage" : "Topptekstbildet er utformet slik at det dekker hele bredden på skjemaet og forblir plassert øverst i skjemaet. For å se topptekstbildet, klikk på forhåndsvisning.",
    "onSubmit" : "Ved innsending",
    "facebookPixelID" : "Facebook-Pixel-ID",
    "facebookPixelIDMessage" : "Ignorer dette feltet hvis du planlegger å bruke dette skjemaet/undersøkelsen inne i trakt",
    "facebookPixelEvents" : "Facebook Pixel Events",
    "onpageView" : "Ved sidevisning",
    "stickyContact" : "Klistret kontakt",
    "stickyContactMessage" : "Remembers and auto-fills contact details when the user returns on the same device and browser.",
    "fieldDescription" : "Beskrivelse av felt",
    "fieldTitle" : "Tittel på felt",
    "queryKey" : "Spørsmålsnøkkel",
    "querykeyTooltipMessage" : "Spørsmålsnøkkelen som kan brukes som URL-parameter for å fylle ut dette feltet",
    "required" : "Obligatorisk",
    "hidden" : "Skjult",
    "hiddenValue" : "Skjult verdi",
    "enableCountryPicker" : "Aktiver landvelger",
    "altText" : "Alt. tekst",
    "alignment" : "Justering",
    "imageWidth" : "Bildebredde",
    "imageHeight" : "Bildehøyde",
    "logic" : "Logikk",
    "pleaseInput" : "Skriv inn",
    "editHTML" : "Rediger HTML",
    "textStyle" : "Tekststil",
    "subText" : "Undertekst",
    "text" : "Tekst",
    "buttonStyle" : "Knappestil",
    "fullWidth" : "Full bredde",
    "htmlMessage" : "Tilpasset HTML skal være her",
    "htmlEditorHeader" : "TILPASSET JAVASCRIPT/HTML",
    "htmlEditorBodyMessage" : "Legg til koden din her",
    "yesSave" : "Ja, lagre",
    "cancelKeep" : "Avbryt, behold",
    "done" : "Fullført",
    "addElement" : "Legg til element",
    "addUrlLike" : "Legg til gyldige nettadresser som",
    "doNotAddRelativePath" : "Ikke legg til relative baner som",
    "or" : "eller",
    "addCustomFields" : "Legg til egendefinerte felt",
    "customFieldSearch" : "Søk etter navn",
    "enterSourceValue" : "Angi kildeverdi",
    "shortLabel" : "Kort etikett",
    "shortLabelPlaceholder" : "Font a Kort etikett",
    "labelPlaceholder" : "Type en etikett",
    "fileUploadPlaceholder" : "Laste opp a Fil",
    "customCSSTooltip" : "Tilpasset CSS har forrang fremfor skjemastyling og temaer og kan ha innvirkning på temaets styling.",
    "fontFamilyTooltip" : "Builder støtter alle typer skrifter hvis du ikke kan se det i listen. Søk i rullegardinmenyen",
    "useGDPRCompliantFont" : "Bruk GDPR-kompatibel skrift",
    "enableTimezone" : "Aktiver tidssone",
    "inputStyle" : "Inndatastil",
    "conditionalLogicAlertOnSubmit" : "Betinget logikk vil ha forrang over meldingen/omdirigeringen her",
    "conditionalLogicAlertOnShowHide" : "Betinget logikk vil ha forrang over de skjulte innstillingene her",
    "placeholderFacebookPixelIdInput" : "Skriv inn Facebook Pixel-ID",
    "doNotShowMessage" : "Ikke vis igjen",
    "creatingForm" : "Opprettet din Skjema...",
    "creatingSurvey" : "Opprettet din Spørreundersøkelse...",
    "creatingQuiz" : "Opprettet quizen din...",
    "errorCreatingForm" : "Det var en feil Opprettet din Skjema. Vennligst prøv igjen.",
    "errorCreatingSurvey" : "Det var en feil Opprettet din Spørreundersøkelse. Vennligst prøv igjen.",
    "errorCreatingQuiz" : "Det oppsto en feil Opprettet quizen din. Vennligst prøv igjen.",
    "redirectMessage" : "You will be redirected to:",
    "themes" : {
      "themes" : "Temaer",
      "alertThemeMessage" : "Hvis du bytter tema, vil du miste alle gjeldende stilendringer.",
      "useTheme" : "Bruk tema",
      "removeTheme" : "Fjern tema"
    },
    "box" : "Boks",
    "line" : "Linje",
    "message" : "Melding",
    "openUrl" : "Åpne URL",
    "borderTypeList" : {
      "dotted" : "Stiplet",
      "dashed" : "Stiplet",
      "solid" : "Fast",
      "none" : "Ingen"
    },
    "button" : "Knapp",
    "emailNotification" : "E-postvarsling",
    "emailNotificationSubheader" : "Motta en e-post når noen fyller ut skjemaet ditt",
    "subject" : "Tema",
    "emailTo" : "E-post (til)",
    "senderName" : "Navn på avsender",
    "senderNameWarning" : "Ditt (underkontonavn) vil bli lagt til hvis det står tomt",
    "emailError" : "Minst én e-postadresse er påkrevd",
    "emailTooltip" : "Den første e-postadressen er angitt for «Til»-feltet. Eventuelle påfølgende e-postadresser vil bli inkludert i «Cc»-feltet.",
    "clear" : "Fjern",
    "showNotificationsSettings" : "Vis varslingsinnstillinger",
    "emailServicePaid" : "Denne funksjonen er en betalt tjeneste og vil medføre gebyrer basert på bruken din.",
    "integration" : "Integrering",
    "validation" : {
      "fieldRequired" : "Filt er obligatorisk",
      "maxLengthExceeded" : "Maks-lengden er overskredet ({max} tegn)"
    },
    "payment" : {
      "payments" : "Betalinger",
      "connected" : "Tilkoblet",
      "connect" : "Koble til",
      "liveModeOn" : "Live-modus",
      "status" : "Status",
      "test" : "Test",
      "live" : "Direkte",
      "paymentFields" : "Betalingsfelt",
      "suggestAnAmount" : "Foreslå et beløp",
      "selectCurrency" : "Velg valuta",
      "tagActiveBGColor" : "Aktiv taggfarge",
      "includeOtherAmount" : "Inkluder annet beløp",
      "footerInfo" : "Bunntekstinfo",
      "paymentType" : "Betalingstype",
      "sellProducts" : "Selg produkter",
      "customAmount" : "Tilpasset beløp",
      "collectPayment" : "Innkreve betaling",
      "generalSettings" : "Generelle felt",
      "securePayments" : "*100 % Låse og trygge betalinger*",
      "error" : {
        "addMainProductFirst" : "Legg til et PRIMÆR Produkt først",
        "priceNotFoundForBumpProduct" : "Pris ble ikke funnet for Fremhevet produkt",
        "productAlreadyAdded" : "Produkt er allerede lagt til"
      },
      "product" : {
        "addProduct" : "Legg til produkt",
        "productSettings" : "Produktinnstillinger",
        "selectProduct" : "Velg produkt",
        "editThisProduct" : "For å redigere dette produktet",
        "clickHere" : "Klikk her",
        "show" : "Vis",
        "description" : "Beskrivelse",
        "image" : "Bilde",
        "layoutSettings" : "Layoutinnstillinger",
        "singleColumn" : "En kolonne",
        "twoColumn" : "To kolonner",
        "threeColumn" : "Tre kolonner",
        "maxProductError" : "Maksimalt 20 produkter er tillatt i et skjema",
        "productSelectPlaceholder" : "Velg et produkt",
        "orderConfirmation" : "Ordrebekreftelse",
        "orderConfirmationWarning" : "En ordrebekreftelse vil vises når betalingen er gjennomført",
        "quantity" : "Mengde",
        "createProduct" : "For å oppretter et produkt",
        "noProductsAdded" : "Ingen produkter lagt til ennå",
        "productsWillShowHere" : "Når Du Inkludere-produkter, vil de Vise opp Høyre henne",
        "chooseProductType" : "Velge Type",
        "mainProduct" : "PRIMÆR Produkt"
      },
      "bumProduct" : {
        "price" : "Pris",
        "variant" : "Variant",
        "headline" : "Overskrift",
        "otoHeadline" : "OTO Overskrift",
        "otoText" : "OTO Hoveddel",
        "enableImage" : "Aktivere Bilde",
        "imageMessage" : "Vi henter Standard produktbilde",
        "orUploadADifferentImage" : "Eller Laste opp et annet bilde",
        "bumpProducts" : "Bump-produkter",
        "bumpProduct" : "Fremhevet produkt",
        "enableBump" : "Aktivere Bump",
        "orderBumpStyle" : "Tilleggsbestilling Stil",
        "classic" : "Klassisk",
        "modern" : "Moderne",
        "icon" : "Ikon",
        "bumpTemplate" : "Velge Mal",
        "highlightText" : "Marker Hoveddel",
        "showPrice" : "Vise Pris",
        "bumpPriceColor" : "Høyeste Pris",
        "bumpIconColor" : "Bump- Ikon",
        "bumpBackgroundColor" : "Bump Bakgrunn",
        "highlightTextColor" : "Marker Hoveddel",
        "headlineColor" : "Overskrift",
        "otoHeadlineColor" : "OTO Overskrift",
        "otoTextColor" : "OTO Hoveddel",
        "bumpBorderColor" : "Bump Kant",
        "priceRequired" : "Pris er obligatorisk",
        "headlineRequired" : "Overskrift er Obligatorisk",
        "bumpProductTooltip" : "En Liten Tillegg tilbudt under Kasse å Multiplisere Sortere Verdi. Kunder kan inkludere det med et enkelt klikk.",
        "templateOne" : "Mal 1",
        "templateTwo" : "Mal 2",
        "templateThree" : "Mal 3",
        "animationIcon" : {
          "none" : "Ingen",
          "arrow" : "Pil",
          "fire" : "Brann",
          "plus" : "Pluss",
          "giftBox" : "Boks",
          "timer" : "Nedtelling",
          "cracker" : "Kjeks",
          "snack" : "Snack",
          "partyBalloon" : "Festballong",
          "flash" : "Blits",
          "money" : "Valuta",
          "spaceShuttle" : "Rom"
        }
      },
      "coupons" : {
        "coupons" : "Kuponger",
        "enableCoupon" : "Aktiver kupong",
        "couponAlignment" : "Kupongjustering",
        "left" : "Venstre",
        "right" : "Høyre",
        "fullWidth" : "Full bredde",
        "tooltipMessage" : "Angi plasseringen av kuponginndata fra typene nedenfor"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Automatisk utfylling av adresse",
      "addressfields" : "Adressefelt",
      "placeholderSearch" : "Søk etter en adresse",
      "autoCompleteTooltip" : "Gir mulighet til å søke etter og automatisk fylle ut adresse.",
      "streetAddress" : "Adresse",
      "autoCompleteAddressTitle" : "Auto Fullfør Adresse",
      "newBadge" : "ny",
      "defaultLabel" : "Adresse",
      "searchPlaceholder" : "Søke Adresse",
      "mandataorySearch" : {
        "title" : "Obligatorisk å velge adresse in Søke Bar",
        "primaryText" : "Automatisk utfylling kun for Adresse",
        "secondaryText" : "Når Aktivert, Når en Bruker samhandler med Adressefilten, Neste må de velge en gyldig adresse til Fortsette.",
        "secondaryText1" : "Når deaktivert Neste kan de Fortsette uten å velge adresse in Søke-linjen."
      }
    },
    "autoResponder" : "Autosvar",
    "autoResponderSubheader" : "Send en automatisk e-post til personen som sender inn skjemaet (e-post inneholder en kopi av informasjonen de skrev inn i skjemaet)",
    "replyToEmail" : "Svar på e-post",
    "open" : "Åpen",
    "won" : "Vunnet",
    "lost" : "Tapt",
    "abandon" : "Forlatt",
    "selectAPipeline" : "Velg en pipeline",
    "stage" : "Etappe",
    "status" : "Status",
    "opportunityValue" : "Mulighetsverdi",
    "createNewPipeline" : "Opprett ny pipeline",
    "editOpportunitySettings" : "Rediger mulighetsinnstillinger",
    "contact" : "Kontakt",
    "opportunity" : "Mulighet",
    "business" : "Bedrift",
    "add" : "Legg til",
    "more" : "Flere",
    "opportunityHeading" : "Hvor vil du at muligheten din skal bli oppdatert?",
    "date" : {
      "dateSettings" : "Datoinnstillinger",
      "dateFormat" : "Datoformat",
      "dateSeparator" : "Datoseparator",
      "dateFormatTooltipMessage" : "Velg et datoformat. D står for dag, M for måned og Å for år",
      "dateSeparatorTooltipMessage" : "Velg en separator som vil skille dag, måned og år i format valgt under datoformat",
      "disablePicker" : "Deaktiver velger"
    },
    "restoreVersion" : "Gjenopprett versjon",
    "versionHistory" : "Versjonshistorikk",
    "errorMessage" : "Feil, prøv på nytt",
    "version" : "Versjon:",
    "currentVersion" : "Nåværende versjon",
    "messageStyling" : "Meldingsstil",
    "validateEmailHeader" : "Bekreft e-post",
    "validateEmailDescription" : "Knappen blir synlig når brukeren skriver inn e-posten sin. Denne funksjonen er utviklet for å hjelpe deg med å generere kvalitetsleads.",
    "validatePhoneHeader" : "Valider telefon",
    "validatePhoneDescription" : "Knappen blir synlig når brukeren går inn på telefonen sin. Denne funksjonen er utviklet for å hjelpe deg med å generere kvalitetsleads.",
    "validatePhoneWarning" : "For å aktivere SMS OTP-verifisering, må du sørge for at telefonnummeret ditt er konfigurert i stedsinnstillingene dine",
    "addAnotherTnc" : "Add another T & C",
    "tnc1" : "T & C 1",
    "tnc2" : "T & C 2",
    "deleteCaps" : "DELETE",
    "deleteConfirmation" : "Type DELETE to confirm",
    "style" : {
      "formLayoutType" : "Skjematype",
      "layoutType" : "Layout Type",
      "surveyType" : "Survey Type",
      "oneColumn" : "Én kolonne",
      "twoColumn" : "To kolonner",
      "singleLine" : "Én linje",
      "fieldWidth" : "Feltbredde",
      "labelAlignment" : {
        "labelAlignment" : "Etikettjustering",
        "labelWidth" : "Etikettbredde"
      },
      "fieldSpacing" : "Avstand mellom feltene",
      "color" : "farge",
      "fontColor" : "Skriftfarge",
      "inputBackgroundColor" : "Bakgrunnsfarge for inndata",
      "inputBorder" : "Tilbakemelding Kant",
      "layout" : "Oppsett",
      "colorsAndBackground" : "Farger og bakgrunn",
      "advanceSettings" : "Avanserte Innstillinger",
      "inputField" : "Inngangsfelt",
      "borderWidth" : "Kantvidde",
      "borderColor" : "Kantfarge",
      "borderStyle" : "Kantlinjestil",
      "fontSize" : "Skriftstørrelse",
      "fontWeight" : "Skriftvekt",
      "labelColor" : "Etikettfarge",
      "placeholderColor" : "Plassholderfarge",
      "shortLabelColor" : "Kort etikettfarge"
    },
    "replyToTooltip" : "Tilpass standard svar-til-e-postadresse ved å bruke {'{'}{'{'}contact.email{'}'}{'}'} for å aktivere svar til kontakten som sender inn skjemaet.",
    "content" : "Innhold",
    "calculations" : "Beregninger",
    "uploadOptions" : "Opplastingsalternativer",
    "opportunitySettingsWarning" : "Vennligst sett opp mulighetsinnstillinger ved å klikke på knappen Edit Opportunity Settings.",
    "question" : "Spørsmål",
    "createContactOnPartialSubmission" : "Opprett kontakt ved delvis innsending",
    "howItWorks" : "Hvordan fungerer det?",
    "createContactOnPartialSubmissionDescription" : "Fullfør lysbildet og klikk «Neste». En ny kontakt opprettes og lagres automatisk.",
    "swapWarningMessageSurvey" : "Hvis du redigerer eller bytter alternativer, vil det påvirke dette egendefinerte feltet på alle steder der feltet brukes. Det kan også tilbakestille betinget logikk. ",
    "swapWarningMessageForm" : "Hvis du redigerer eller bytter alternativer, vil det påvirke dette egendefinerte feltet på alle steder der feltet brukes. ",
    "migrationWarningMessage" : "This functionality has been migrated to the Survey Conditional Logic.",
    "optionLabel" : "Alternativ-etikett",
    "calculationValue" : "Beregningsverdi",
    "addOption" : "Legg til alternativ",
    "enableCalculations" : "Aktiver beregninger",
    "allowOtherOption" : "Allow Other Option",
    "productSelectionSubtext" : "Aktivere Individ Eller flere produktvalg",
    "multi" : "Flere",
    "single" : "Individ",
    "productSelectionHeading" : "Produkt",
    "spreadToColumns" : "Spred til kolonner",
    "columns" : "Kolonner",
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble",
    "integratePopup" : {
      "embedCode" : "Embed Code",
      "useInFunnelOrEmbedCode" : "Use in Funnel/ Embed Code",
      "iframeEmbed" : "Sett inn iframe",
      "funnel" : {
        "funnel" : "Trakt",
        "chooseStep" : "Velge a Sritt",
        "copyCodeAndOpenFunnel" : "Kopiere Kode og Åpne Trakt"
      },
      "share" : {
        "share" : "Share",
        "shareViaSocials" : "Slett Via sosiale medier",
        "copyLink" : "Kopier lenke"
      },
      "email" : {
        "email" : "E-post",
        "shareViaEmail" : "Slett Via e-post",
        "emailButton" : "E-post",
        "blankTemplate" : "Mal mal",
        "emailMarketingTemplates" : "E-post Markedsføring",
        "or" : "Eller",
        "chooseTemplate" : "Choose from your templates",
        "continue" : "Fortsette"
      }
    },
    "rating" : {
      "icon" : "Ikon",
      "iconAlignment" : "Ikon Justering",
      "count" : "Antall",
      "lowestRating" : "Min.. Vurdering",
      "highestRating" : "Maks-vurdering",
      "iconSelectedState" : "Ikon Valgt Stat",
      "iconUnselectedState" : "Ikon Ikke valgt Stat",
      "rating" : "Vurdering",
      "ratingSettings" : "Innstillinger",
      "calculationType" : {
        "calculationType" : "Hvordan Arkivere Rating Filt in Tilpasset Filt",
        "calculationTypeTooltip" : "Når Du Hyppighet noe 4 Fra 5 stjerner, betyr det: - Absolutt: 4 Fra 5 - Prosentdel: 80 - Brøk: 0,8",
        "absolute" : "Absolutt",
        "percentage" : "Prosentdel",
        "fraction" : "Brøk"
      }
    },
    "desktopMode" : "Skrivebordmodus",
    "mobileMode" : "Mobilmodus",
    "versions" : "Varianter",
    "advanced" : "Advanced",
    "edit" : "Edit",
    "settings" : "Settings",
    "submissions" : "Submissions",
    "undo" : "Undo",
    "redo" : "Redo",
    "confirmationMessage" : "Confirmation Message",
    "deleteOption" : "Slette-alternativ",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Sletter et alternativ vil påvirke denne Tilpasset-filten på tvers av hvert eneste seter der filten brukes. Er du sikker på at du ønsker å Slette det?",
      "validationMessage" : "Vennligst skriv inn Slette til Lagre.",
      "validationError" : "Vennligst skriv inn Slette"
    },
    "disqualifyImmediately" : "Disqualify Immediately",
    "disqualifyAfterSubmit" : "Disqualify After Submit",
    "generalSettings" : "Generelt Innstillinger",
    "advancedSettings" : "Avanserte Innstillinger",
    "customFieldName" : "Tilpasset Industri Navn",
    "customFieldNameTooltip" : "Denne Industri Navn er unik per Tilpasset Industri.",
    "uniqueKey" : "Unik nøkkel",
    "uniqueKeyTooltip" : "Denne Viktige er unik per Tilpasset Industri.",
    "survey" : {
      "layoutType" : "Survey Type",
      "oneQuestionPerPage" : "One Question at a Time",
      "allQuestionsOnePage" : "Many at a Time"
    },
    "quizQuestions" : "Quiz Forespørsel",
    "choiceElements" : "Choice Komponenter",
    "otherElements" : "Annen/annet Komponenter",
    "listEditor" : {
      "prefillValueHeader" : "Verdi for Forhåndsfylle",
      "labelPlaceholder" : "Merkelapp",
      "valuePlaceholder" : "Verdi",
      "optionRequiredError" : "Alternativet Felt er Obligatorisk"
    },
    "field" : "Felt",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Legge til Felt",
      "fieldLabel" : "Felt",
      "numberLabel" : "høy"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Fil",
      "all" : "hver eneste",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok" : "Ok",
    "select" : "Velg",
    "allowMultipleFiles" : "Aktivere flere filer",
    "maxFileLimit" : "Maks Fil",
    "privacyPolicy" : "Retningslinjer for personvern",
    "termsOfService" : "Vilkår for tjenesten"
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Individuelt valg",
      "multipleChoice" : "Flere valg",
      "yesNo" : "Ja /Nei",
      "shortAnswer" : "Kort Besvart",
      "longAnswer" : "Long Besvart",
      "number" : "høy",
      "singleDropdown" : "Individuell Rullegardinmeny",
      "multiDropdown" : "Multi- Rullegardinmeny"
    },
    "personal" : {
      "fullName" : "Full Navn",
      "firstName" : "Fornavn",
      "lastName" : "siste Navn",
      "dateOfBirth" : "Fødselsdato",
      "phone" : "Telefon",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Knapp"
    },
    "integration" : {
      "sellProducts" : "Selg produkter",
      "collectPayment" : "Innkreve Utbetaling"
    },
    "address" : {
      "address" : "Adresse",
      "streetAddress" : "Adresse",
      "city" : "By",
      "state" : "Stat",
      "country" : "Land",
      "postalCode" : "Kode",
      "organization" : "Gruppe",
      "website" : "Nettsted",
      "websitePlaceholder" : "Nett-URL går her"
    },
    "text" : {
      "singleLine" : "Individ Linje",
      "multiLine" : "Flere Linje",
      "textBoxList" : "Tekste Firkant Liste"
    },
    "choiceElements" : {
      "singleDropdown" : "Individuell Rullegardinmeny",
      "multiDropdown" : "Multi- Rullegardinmeny",
      "checkbox" : "Avmerkingsboks",
      "radio" : "Radio"
    },
    "customized" : {
      "text" : "Tekste",
      "html" : "Html",
      "htmlPlaceholder" : "Tilpasset HTML skal være her",
      "captcha" : "Captcha",
      "source" : "Kilde",
      "termsAndConditions" : "T & C",
      "termsAndConditionsPlaceholder" : "Jeg godtar vilkår og betingelser Utstedt Via selskapet. Ved å oppgi telefonnummeret mitt, godtar jeg Arve tekste-meldinger fra virksomheten.",
      "score" : "Poengsum"
    },
    "other" : {
      "image" : "Bilde",
      "fileUpload" : "Laste opp av Fil",
      "monetary" : "Monetær",
      "number" : "høy",
      "datePicker" : "Dato",
      "signature" : "Signatur"
    },
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble"
  },
  "survey" : {
    "typeOfBuilder" : "Spørreundersøkelse",
    "survyeStyle" : "Stil for spørreundersøkelse",
    "surveyName" : "Navn på spørreundersøkelse",
    "surveyElement" : "Undersøkelseselement",
    "addSurveyElement" : "Legg til undersøkelseselement",
    "cloneSlide" : "Klon lysbilde",
    "unsavedAlertMessage" : "Undersøkelsen har arbeid som ikke er lagret. Er du sikker på at du vil forlate og forkaste alt arbeid som ikke er lagret?",
    "thirdPartyScriptAlertMessage" : "Tredjepartsskript inne i HTML-blokken kan gi sterk funksjonalitet, men de medfører også risiko for personvern, sikkerhet, ytelse og sideoppførsel. Vi anbefaler derfor at du leser gjennom innholdet i dette skriptet før du lagrer det i undersøkelsen.",
    "integrateHeader" : "Integrer undersøkelsen",
    "integrateSubHeader" : "Bruk følgende alternativer for å integrere den egendefinerte spørreundersøkelsen på nettstedet ditt",
    "integrateCopyLinkMessage" : "Kopier lenken nedenfor og del den enkelt hvor du måtte ønske.",
    "onSurveySubmission" : "Ved innsending av undersøkelse",
    "surveySettings" : "Innstillinger for undersøkelse",
    "oneQuestionAtTime" : "Ett spørsmål om gangen",
    "backButton" : "Tilbakeknapp",
    "backButtonTooltipMessage" : "Back button will help users to move to the previous slide",
    "disableAutoNavigation" : "Deaktiver automatisk navigasjon",
    "disableAutoNavigationTooltipMessage" : "Navigerer automatisk til Neste Skyve Etter a Bruker svarer.",
    "autoNavigation" : "Auto navigasjon",
    "autoNavigationTooltipMessage" : "Navigerer automatisk til Neste Skyve Etter a Bruker svarer.",
    "progressBar" : "Fremdriftslinje",
    "progressBarTooltipMessage" : "Turning this off will remove the Progress Bar from the survey",
    "disableAnimation" : "Deaktiver animasjon",
    "disableAnimationTooltipMessage" : "Hvis du slår denne på, deaktiveres lysbildeovergangsanimasjonen",
    "scrollToTop" : "Bla til toppen",
    "scrollToTopTooltipMessage" : "Hvis den er slått på, vil undersøkelsen gå til toppen på neste lysbilde",
    "footerHTML" : "HTML for bunntekst",
    "footerHTMLMessage" : "Du kan skrive tilpasset CSS (ved hjelp av stilkode) og HTML i samme boks",
    "editFooter" : "Rediger bunntekst",
    "disqualifySettings" : "Disqualify Settings",
    "disqualifyImmediately" : "Diskvalifiser umiddelbart",
    "disqualifyAfterSubmit" : "Diskvalifiser etter innsending",
    "disqualifyImmediatelyLabel" : "Immediately",
    "disqualifyAfterSubmitLabel" : "After Submit",
    "slideConflictAlertMessage" : "Dette lysbildet inneholder flere spørsmål som har logikk ved dem. Dette kan føre til utilsiktet atferd",
    "addSlide" : "Legg til lysbilde",
    "settings" : "Innstillinger",
    "delete" : "Slett",
    "slideDeleteAlertMessage" : "Er du sikker på at du vil slette denne lysbildet?",
    "slideDeleteBetweenAlertMessage" : "Dette vil omorganisere de andre lysbildene, er du sikker på at du vil slette dette lysbildet?",
    "slideLabel" : "Slide {n}",
    "slideName" : "Lysbildenavn",
    "slidePosition" : "Skyveposisjon",
    "jumpTo" : "Hopp til",
    "jumpToSubText" : "Jump to a specific slide",
    "enableTimezoneSurvey" : "Hvis du aktiverer dette alternativet, registreres tidssoneinformasjonen til personen som sender inn undersøkelsen",
    "footer" : {
      "footer" : "Bunntekst",
      "enableNewFooter" : "Aktiver ny bunntekst",
      "stickToSurvey" : " Hold deg til undersøkelsen",
      "backgroundFill" : "Bakgrunnsfyll",
      "footerHeight" : "Høyde på bunntekst",
      "enableProgressBar" : "Aktiver fremdriftslinje",
      "buttons" : "Knapper",
      "button" : "Knapp",
      "buttonType" : "Knapptype",
      "fillNext" : "Fyll (neste)",
      "fillPrevious" : "Fyll (tidligere)",
      "fillSubmit" : "Fyll ut (send inn)",
      "textColor" : "Knappetekst",
      "position" : "Posisjon",
      "previousText" : "Forrige (tekst)",
      "nextText" : "Neste (tekst)",
      "submitText" : "Send inn (tekst)",
      "fillComplete" : "Innfylling fullført",
      "fillInactive" : "Innfylling inaktiv",
      "footerType" : "Bunnteksttype",
      "stickToCard" : "Sett fast på kortet",
      "stickToPage" : "Sett fast på siden",
      "stepTextColor" : "Sritt Hoveddel Farge",
      "progressBarFill" : "Fremdriftslinje Fylle",
      "progressBarInactive" : "Fremdriftslinje Inaktiv",
      "arrowFill" : "Pil Fylle",
      "submitColorMobile" : "Send inn (Farge)",
      "arrowFillColor" : "Pil Fylle Farge"
    },
    "surveyNotfication" : "Spørreundersøkelsesvarsel",
    "style" : {
      "surveyPadding" : "Undersøkelses-padding"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Survey",
      "share" : {
        "openFormLink" : "Åpne Spørreundersøkelse Lenke"
      },
      "email" : {
        "emailSubheader" : "Skape en tom e-post og Sett inn Spørreundersøkelsen din, Eller Velge a Mal og Sett inn it Umiddelbart."
      }
    },
    "autoResponderSubheader" : "Send en automatisk e-post til personen som sender inn undersøkelsen (e-posten inneholder en kopi av informasjonen de har lagt inn i undersøkelsen)",
    "switchToOneQuestionAtTimeOn" : "Å aktivere «One Spørsmål at a Dato» forstyrrer din Nåværende betingede Logikk",
    "switchToOneQuestionAtTimeOff" : "Deaktiver «One Spørsmål at a Dato» påvirker din betingede Logikk Konfig",
    "switchToOneQuestionAtTimeOnWarning" : "Noen betingelser vil ikke lenger fungere som forventet Når spørsmålene er Møtte opp en mot en Dato.",
    "switchToOneQuestionAtTimeOffWarning" : " Noen betingelser utviklet for Flyt med individuelle spørsmål vil slutte å fungere som tiltenkt.",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Survey."
  },
  "form" : {
    "typeOfBuilder" : "Skjema",
    "formStyle" : "Skjemastil",
    "formElement" : "Skjemaelement",
    "addFormElement" : "Legg til skjemaelement",
    "addConditionalLogic" : "Legg til betinget logikk",
    "openConditionalLogic" : "Open Conditional Logic",
    "inlineForm" : "Inline-skjema",
    "formName" : "Skjemanavn",
    "fullScreenMode" : "Fullskjermmodus",
    "fullScreenModetooltip" : "Å slå den på vil føre til at skjemaet utvides over hele bredden på beholderen, og strekker seg til kanten av innebyggingsområdet mens det holder seg til skjemaets bredde.",
    "enableTimezoneForm" : "Aktivering av dette alternativet vil fange opp tidssoneinformasjonen til personen som sender inn skjemaet",
    "formSettings" : "Innstillinger for skjema",
    "unsavedAlertMessage" : "Skjemaet har ulagret arbeid. Er du sikker på at du vil forlate og forkaste alt arbeid som ikke er lagret?",
    "thirdPartyScriptAlertMessage" : "Tredjepartsskript inne i HTML-blokken kan gi sterk funksjonalitet, men de medfører også risiko for personvern, sikkerhet, ytelse og sideoppførsel. Vi anbefaler derfor at du leser gjennom innholdet i dette skriptet før du lagrer det i skjemaet.",
    "onFormSubmission" : "Ved innsending av skjema",
    "integrateForm" : "Integrer skjema",
    "embedlayoutType" : "Sett inn Type Oppsett",
    "embedlayoutTypeSubMessage" : "Velg en layout som skal bygges inn i en trakt eller et eksternt nettsted",
    "triggerType" : "Triggertype",
    "showOnScrolling" : "Vis på scrolling",
    "showAfter" : "Vis etter",
    "seconds" : "sekunder",
    "alwaysShow" : "Vis alltid",
    "activationOptions" : "Aktiveringsalternativer",
    "activateOn" : "Aktiver på",
    "visit" : "besøk",
    "alwaysActivated" : "Alltid aktivert",
    "deactivationOptions" : "Alternativer for deaktivering",
    "deactivateAfterShowing" : "Deaktiver etter visning",
    "times" : "ganger",
    "deactiveOnceLeadCollected" : "Deaktiveres når leaden er hentet inn",
    "neverDeactivate" : "Aldri deaktivere",
    "copyEmbedCode" : "Kopier innbyggingskode",
    "copyFormLink" : "Kopier skjemalenke",
    "openFormLink" : "Åpne skjemalenke",
    "inline" : "Innebygd",
    "inlineDescription" : "Et innebygd skjema vises sammen med innholdet på siden som et innebygd element. Det legges ikke over og kan ikke lukkes eller minimeres.",
    "inlineHoverDescription" : "Et innebygd skjema vises sammen med innholdet på siden som et innebygd element. Det legges ikke over og kan ikke lukkes eller minimeres.",
    "popup" : "Popup",
    "popupDescription" : "En popup viser form som et overlegg inne i en lysboks. Den kan ikke minimeres, men lukkes.",
    "popupHoverDescription" : "En popup viser form som et overlegg inne i en lysboks. Den kan ikke minimeres, men lukkes.",
    "politeSlideIn" : "Høflig varsel",
    "politeSlideInDescription" : "Et høflig varsel vises på bunnen av skjermen og forsvinner når den lukkes",
    "politeSlideInHoverDescription" : "Vises nederst på skjermen og forsvinner når den lukkes",
    "stickySidebar" : "Klistret sidefelt",
    "stickySidebarDescription" : "Et klistret sidefelt vises på siden av skjermen og kan minimeres til en fane som fester seg til siden av vinduet",
    "stickySidebarHoverDescription" : "Vises på siden av skjermen og kan minimeres til en fane som fester seg til siden av vinduet",
    "allowMinimize" : "Tillat minimering",
    "conditonalLogic" : {
      "conditions" : "Betingelser",
      "noExistingCondition" : "Ingen eksisterende betingelser ennå",
      "freeRoamMessage" : "Du kan bevege deg fritt uten regler – i hvert fall inntil videre",
      "addNewCondition" : "Legg til ny betingelse",
      "redirectToUrl" : "Omdiriger til URL",
      "displayCustomMessage" : "Vis egendefinert melding",
      "disqualifyLead" : "Diskvalifiser lead",
      "showHideFields" : "Vis/skjul felt",
      "jumpTo" : "Jump To",
      "redirectToUrlSubText" : "Omdiriger Bruker etter innsending",
      "displayCustomMessageSubText" : "Vise-meldinger basert på På Bruker-innganger",
      "disqualifyLeadSubText" : "Filtrere ut oppføringer under spesifikke betingelser",
      "showHideFieldsSubText" : "Endre Følte Synlighet dynamisk",
      "openBelowUrl" : "Åpne URL-en nedenfor",
      "showCustomMessage" : "Vis egendefinert melding",
      "alertConditionDelete" : "Er du sikker på at du vil slette denne betingelsen?",
      "deleteCondition" : "Slett betingelse",
      "conditionExecutedMessage" : "Betingelsene vil bli utført i rekkefølgen ovenfra og ned.",
      "allOperationOptions" : {
        "isEqualTo" : "Er lik",
        "isNotEqualTo" : "Er ikke lik",
        "contains" : "Inneholder",
        "startsWith" : "Begynner med",
        "endsWith" : "Slutter med",
        "isEmpty" : "Er tom",
        "isFilled" : "Er fylt",
        "before" : "Før",
        "after" : "Etter",
        "greaterThan" : "Større enn",
        "lessThan" : "Mindre enn"
      },
      "logic" : {
        "if" : "Hvis",
        "then" : "Deretter",
        "and" : "Og",
        "or" : "Eller"
      },
      "phoneAlertMessage" : "For å søke etter telefonnumre med landskode, må du inkludere «+»-symbolet i søket ditt.",
      "deleteAlertMessage" : "Er du sikker på at du vil slette dette feltet? Betingelsen som er knyttet til dette feltet, vil også bli fjernet.",
      "deleteField" : "Slett felt",
      "jumpToDescription" : "Jump to a specific slide when conditions are met",
      "jumpToSlide" : "Jump To Slide",
      "selectSlideToJumpTo" : "Select slide to jump to",
      "selectedSlide" : "Selected slide"
    },
    "minimizedTitlePlaceholder" : "Minimert tittel",
    "dragYourElementFromLeft" : "Dra elementene dine hit fra venstre",
    "formNotification" : "Skjema for varsling",
    "style" : {
      "formPadding" : "Skjema-padding"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Form",
      "share" : {
        "openFormLink" : "Åpne Skjema Lenke"
      },
      "email" : {
        "emailSubheader" : "Skape en tom e-post og Sett inn din Skjema, Eller Velge a Mal og Sett inn it Umiddelbart."
      }
    },
    "choosePosition" : "Velge Status"
  },
  "quiz" : {
    "quizElement" : "Quiz-element",
    "quizNotification" : "Quiz-varsling",
    "viewAndCustomise" : "Se og tilpass",
    "categoryAndScore" : "Kategori og poengsum",
    "provideFeedback" : "Gi tilbakemelding",
    "addQuizElement" : "Legg til quiz-element",
    "typeOfBuilder" : "Quiz",
    "addQuestions" : "Legge til spørsmål",
    "dragAndDropQuestion" : "Dra og slipp et Spørsmål her.",
    "addNewPage" : "Legge til ny Side",
    "editTemplate" : "Redigere Mal",
    "clonePage" : "Clone Page",
    "category" : {
      "category" : "Kategori",
      "watchVideo" : "Se denne Video for å lære mer om hvordan kategorien påvirker resultatsiden!",
      "useCategoryWhen" : "Bruk Kategorier Når",
      "manageCategories" : "Administrere Kategorier",
      "howItWorks" : "Hvordan fungerer dette 🤔",
      "howItWorks2" : "Hvordan fungerer dette",
      "addCategoryMessage" : "Legge til en ny Kategori",
      "assignCategoryMessage" : "Tilordne en Kategori til hvert eneste alternativ",
      "editResultsMessage" : "Vise Kategori-score in Resultat Side",
      "addCategory" : "Legge til Kategori",
      "deleteCategoryAlertMessage" : "Å slette en kategori vil resultere i hvile av den kategorien in hvert eneste alternativet",
      "editOrAddNewCategories" : "Du kan Redigere Eller Inkludere nye kategorier",
      "toEvaluateTheResponder" : "For å sammenligne responderen basert på flere faktorer",
      "showMultipleCategoryScore" : "Vise flere Kategori-score in Resultat Side",
      "displayVaryingContent" : "Visning varierende Innhold På resultatene Side avhengig På Kategori-poengsummen",
      "theOptionFieldIsRequired" : "The option field is required",
      "addManage" : "Legge til / Administrere"
    },
    "quizSettings" : "Quiz-innstillinger",
    "onQuizSubmission" : "Ved innlevering av quiz",
    "settings" : "Innstillinger",
    "deletePage" : "Slett side",
    "quizResult" : {
      "resultTemplate" : "Resultatmal",
      "quizResultAlertMessage" : "Valgt resultatside vil vises når quizen er fullført"
    },
    "autoResponderSubheader" : "Send en automatisk e-post til personen som sender inn quizen (e-posten inneholder en kopi av informasjonen de har lagt inn i quizen)",
    "integrateHeader" : "Integrer quiz",
    "integrateSubHeader" : "Bruk følgende alternativer for å integrere din egendefinerte quiz på nettstedet ditt",
    "integrateCopyLinkMessage" : "Kopier lenken nedenfor og del den enkelt hvor du måtte ønske.",
    "pageLabel" : "Page {n}",
    "pageName" : "Sidenavn",
    "pagePosition" : "Sideposisjon",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Quiz.",
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Quiz",
      "share" : {
        "openFormLink" : "Åpne quiz- Lenke"
      },
      "email" : {
        "emailSubheader" : "Skriv inn en tom e-post og sett inn quizen din, Eller Velge a Mal og Sett inn it Umiddelbart."
      }
    }
  }
}
